export default [
  {
    key: "increasement",
    sortable: false,
    sortField: "createdAt",
    label: "label.no",
  },
  {
    key: "chatChannelName",
    sortable: false,
    label: "field.chatChannelName",
    class: "break-spaces",
  },
  {
    key: "conversationDate",
    sortable: false,
    label: "field.conversationDate",
  },
  {
    key: "createdAt",
    sortable: false,
    label: "field.createDate",
  },
  {
    key: "actions",
    label: "general.action",
  },
];
